import { render, staticRenderFns } from "./AddAcolhimento.vue?vue&type=template&id=d0cc9fbc"
import script from "./AddAcolhimento.vue?vue&type=script&lang=js"
export * from "./AddAcolhimento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports